import serviceimg from '../assets/images/about_img.png';
import PageHeader from '@/components/PageHeader';

import team1 from "../../src/assets/images/Dr_Ashok_Omray.png";
import team2 from "../../src/assets/images/Dr_Sagar_Vichare.png";
import team5 from "../../src/assets/images/Ms_Ashlesha_Kambli.png";
import team4 from "../../src/assets/images/Dr_Ashok_Mohanty.png";

function TeamSynopsis() {
  return (
    <div className="font-sans ">

      <PageHeader title='Expert Team Synopsis' imageUrl={serviceimg} breadcrumbs={['Home', 'Expert Team Synopsis']} />
      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Our Expert Team Synopsis
        </h2>

        <div className="space-y-8">
          

          {/* Team Member 4 - Dr. Ashok Omray */}
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="w-full md:w-48 h-48">
              <img src={team1} alt="Dr. Ashok Omray" className="w-full h-full object-contain" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-[#05326D] mb-2">Dr. Ashok Omray</h3>
              <p className="text-sm text-[#B5AB28] font-semibold mb-3">President | Business Development Professional</p>
              <p className="text-[#05326D]">
                Dr. Ashok Omray is an experienced President with a demonstrated history of working in the pharmaceuticals industry. Skilled in Verification and Validation (V&V), Pharmaceutics, Good Laboratory Practice (GLP), Generic Programming, and Validation. Dr. Omray is a strong business development professional with a Ph.D., B. Pharm., and M. Pharm., focused in Pharmaceutical Sciences from University of Saugar, Sagar, M.P. India.
              </p>
            </div>
          </div>

          {/* Team Member 2 - Dr. Ashok Mohanty */}
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="w-full md:w-48 h-48">
              <img src={team4} alt="Dr. Ashok Mohanty" className="w-full h-full object-contain" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-[#05326D] mb-2">Dr. Ashok Mohanty</h3>
              <p className="text-sm text-[#B5AB28] font-semibold mb-3">Founder Member | Innovation Leader in Pharmaceutical Coatings</p>
              <p className="text-[#05326D] mb-2">
                Dr. Ashok Mohanty was the founder member who brought innovations towards dry ready mix coating dispersions at Ideal Cures. With 30 years of experience in pharmaceutical coatings and technical OSD formulation, he has developed various types of pharmaceutical coating excipients and specialty products including neutral pellets for MUPS technology and taste masking specialty excipients for OSD.
              </p>
              <p className="text-[#05326D]">
                Dr. Mohanty is recognized as an expert in developing enteric methacrylic copolymers in India. He holds a Doctorate and B. Pharma from Orissa University and is an FDA-authorized chemist in India, responsible for approving bulk APIs, formulations, and excipients in compliance with current regulations.
              </p>
            </div>
          </div>

          {/* Team Member 1 - Ms. Ashlesha Kambli */}
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="w-full md:w-48 h-48">
              <img src={team5} alt="Ms. Ashlesha Kambli" className="w-full h-full object-contain" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-[#05326D] mb-2">Ms. Ashlesha Kambli</h3>
              <p className="text-sm text-[#B5AB28] font-semibold mb-3">FDA-Authorized Chemist | Specialist in Pharmaceutical Dry Ready-Mix Coating Dispersions for Solid Oral Dosage Forms</p>
              <p className="text-[#05326D] mb-2">
                <span className='font-semibold'>Core Competencies</span>
                <span className='pl-4'>
                  <br/>
                  • Pharmaceutical formulation & process development <br/>
                  • Tablet coating technologies (aesthetic & functional) <br/>
                  • Process optimization & scale-up (lab to commercial) <br/>
                  • Risk management (FMEA, hazard assessment, mitigation) <br/>
                  • Regulatory compliance (cGMP, ICH, USP) <br/>
                  • Equipment qualification & troubleshooting <br/>
                  • Innovation in excipients (taste masking, controlled release, nutraceuticals) <br/>
                  • Cross-team collaboration & technical training <br/>
                </span>
              </p>
              <p className="text-[#05326D]">
                <span className='font-semibold'>Manufacturing Expertise</span>
                <span className='pl-4'>
                  <br/>
                  • Solid dosage manufacturing (granulation, compression, coating, polishing).<br/>
                  • Functional coating systems: enteric, controlled-release, moisture barrier, taste masking.<br/>
                  • Excipient technology: PVA, alginate, xanthan, natural colorants, pearlescent pigments.<br/>
                  • Process validation: BMR documentation, batch scale-up trials, technology transfer.<br/>
                  • Equipment handling: high-shear mixers, fluidized bed coaters, polishing pans, AHUs.<br/>
                  • Quality systems: CAPA, deviation handling, root cause analysis.<br/>
                </span>
              </p>
            </div>
          </div>

          {/* Team Member 3 - Dr. Sagar M. Vichare */}
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="w-full md:w-48 h-48">
              <img src={team2} alt="Dr. Sagar M. Vichare" className="w-full h-full object-contain" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-[#05326D] mb-2">Dr. Sagar M. Vichare</h3>
              <p className="text-sm text-[#B5AB28] font-semibold mb-3">Global Regulatory Affairs & GMP Expert</p>
              <p className="text-[#05326D] mb-2">
                Dr. Sagar M. Vichare is an innovative global regulatory affairs and GMP expert in the pharmaceutical excipients industry. With an impressive 26-year track record at companies like Colorcon and Ideal Cures, his expertise lies in excipients and global registration strategies, enabling numerous life science companies to successfully register their products in diverse markets worldwide, including the US, Latin America, Europe, and Asia.
              </p>
              <p className="text-[#05326D]">
                Dr. Vichare holds a Doctorate, M. Tech from BITS Pilani, and MSc in Chemistry from University of Mumbai. He is an FDA-authorized chemist in India, responsible for approving drug formulations under QC – Chemical, Instrumentation, and Microbiology, in compliance with current regulations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamSynopsis;



